<template>
  <div data-aos="zoom-out" data-aos-duration="1000">
    <div
      :class="{ 'default-container': isLargeScreen }"
      class="title-section mt-4"
    >
      <h2 class="merriweather-reg-26">
        Découvrez l'expérience
        <span class="merriweather-reg-40 mb-2">Hortense</span>
      </h2>
      <h3 class="subtitle mt-2">Bien plus qu'une simple nuit</h3>
      <p class="raleway-reg-p16">
        Pour tous ceux qui préfèrent savourer les instants, Hortense
        sélectionne des lieux d'exception où nature, authenticité et
        moments de partage se rencontrent. Familles, amis ou couples,
        reconnectez-vous.
      </p>
    </div>

    <div
      :class="{ 'default-container': isLargeScreen }"
      class="experience-hortense"
    >
      <div :class="{ 'container-fluid': isLargeScreen }">
        <div
          :class="containerClasses"
          id="scrollerr"
          style="overflow: scroll; overflow-y: hidden"
        >
          <div
            class="col-proposition col-weekend"
            :style="colWeekendStyle"
          >
            <div
              class="card-proposition"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <img
                src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/hortense-experience-exclusive.webp"
                alt="1"
                class="mb-2"
              />

              <p class="element raleway-bold-h3 mt-2 mb-2">
                LES MOMENTS EXCLUSIFS
              </p>
              <p class="element raleway-reg-p16 mt-2">
                Vivez des instants uniques grâce à des services
                négociés pour vous: massages offerts, diners privés.
                expériences sur-mesure et attentions personnalisées.
              </p>
            </div>
          </div>

          <div
            class="col-proposition col-weekend"
            :style="colWeekendStyle"
          >
            <div
              class="card-proposition"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <img
                src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/hortense-experience-culinaire.webp"
                alt="2"
                class="mb-2"
              />
              <p class="element raleway-bold-h3 mt-2 mb-2">
                LES SAVEURS LOCALES
              </p>
              <p class="element raleway-reg-p16 mt-2">
                Séjournez dans des hébergements d'exception proposant
                des restaurants où déguster des produits du terroir
                sublimés par une cuisine authentique et raffinée.
              </p>
            </div>
          </div>

          <div
            class="col-proposition col-weekend"
            :style="colWeekendStyle"
          >
            <div
              class="card-proposition"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <img
                src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/hortense-experience-bien-etre.webp"
                alt="3"
                class="mb-2"
              />
              <p class="element raleway-bold-h3 mt-2 mb-2">
                LE BIEN-ÊTRE
              </p>
              <p class="element raleway-reg-p16 mt-2">
                Ressourcez-vous dans des hébergements soigneusement
                sélectionnés, proposant des soins apaisants et des
                espaces dédiés à la détente.
              </p>
            </div>
          </div>

          <div
            class="col-proposition col-weekend"
            :style="colWeekendStyle"
          >
            <div
              class="card-proposition"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <img
                src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/hortense-experience-locale.webp"
                alt="4"
                class="mb-2"
              />
              <p class="element raleway-bold-h3 mt-2 mb-2">
                LES ACTIVITÉS
              </p>
              <p class="element raleway-reg-p16 mt-2">
                Vivez des expériences uniques: saveurs gourmandes,
                découvertes cenologiques, instants au bord de l'eau,
                aventures sportives. immersions culturelles, ateliers
                DIY.
              </p>
            </div>
          </div>

          <div
            class="col-proposition col-weekend card-3-color"
            :style="colWeekendStyle"
          >
            <div
              class="card-proposition"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <div class="button-section">
                <button
                  class="create-account-btn"
                  @click="showModal = true"
                >
                  Je crée mon compte
                </button>
                <a class="login-link" @click="showModallogin = true"
                  >Je me connecte</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modalsignup v-if="showModal" @close="setUser"></Modalsignup>
    <Modallogin v-if="showModallogin" @close="setUser"></Modallogin>
  </div>
</template>

<script>
import Modalsignup from "./modals/Modalsignup.vue";
import Modallogin from "./modals/Modallogin.vue";
import AOS from "aos";

export default {
  name: "ExperienceHortense",
  components: { Modalsignup, Modallogin },
  data() {
    return {
      showModal: false,
      showModallogin: false,
      isLargeScreen: window.innerWidth > 768,
    };
  },
  computed: {
    containerClasses() {
      return {
        "d-flex": true,
        "flex-row": true,
        "mb-5": true,
      };
    },
    colWeekendStyle() {
      return {
        marginLeft: this.isLargeScreen ? "40px" : "20px",
      };
    },
    cardPropositionStyle() {
      return {
        "min-width": this.isLargeScreen ? "250px" : "280px",
      };
    },
    defaultContainer() {
      return {
        padding: "20px",
        margin: isLargeScreen ? "0 3rem" : 0,
      };
    },
  },
  mounted() {
    window.addEventListener("resize", this.checkScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize);
  },
  methods: {
    setUser(user) {
      this.user = user;
      this.showModal = false;
      this.showModallogin = false;
    },
    checkScreenSize() {
      this.isLargeScreen = window.innerWidth > 768;
    },
  },
  mounted() {
    AOS.init();
  },
};
</script>

<style
  lang="scss"
  scope="app/assets/stylesheets/components/tips"
></style>

<style lang="scss" scoped>
.experience-hortense {
  padding: 0 20px;
  position: relative;
  color: #333;
  left: -25px;
}

.experience-hortense::before {
  content: "";
  position: absolute;
  top: 28%;
  left: 0;
  right: 0;
  bottom: 10%;
  z-index: -1;
}

.title-section {
  background-color: rgba(255, 255, 255, 0.8);
  padding: 20px;
  text-align: center;
  margin-top: 40px;
}

.bold-text {
  font: 40px / 33px Merriweather;
}

.title-section h2 {
  margin: 0;
  color: #333;
}

.cards-section {
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

/* Add horizontal scroll for mobile */
@media (max-width: 768px) {
  .cards-section {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
  }

  .card-experience {
    min-width: 280px;
    margin-right: 16px;
    scroll-snap-align: start;
  }
  .title-section {
    text-align: left;
  }
}

.card-experience {
  background-color: rgba(255, 255, 255);
  width: 320px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  margin-top: 40px;
  position: relative;
  z-index: 1;
  margin-bottom: 1rem;
}

.card-middle {
  margin-top: -20px;
  z-index: 2;
}

.card-upper-section {
  padding: 20px;
}

.card-1-color {
  background-color: #cfe5dc;
}

.card-2-color {
  background-color: #000000;
  color: white;
}

.card-3-color {
  background-color: #3b6152;
  color: white;
  a {
    color: white;
    text-decoration-color: white;
  }
}

.card-lower-section {
  padding: 20px;
  flex-grow: 1;
}

.card-experience h3 {
  margin: 0;
  font-size: 1.5rem;
}

.card-experience p {
  font-family: Raleway;
  line-height: 1.5;
  font-size: 17px;
}

.button-section {
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.create-account-btn {
  background-color: white;
  color: #3b6152;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 10px;
}

.login-link {
  text-decoration: none;
  color: white;
  font-size: 1rem;
  border-bottom: 1px solid white;
  cursor: pointer;
}
.container-fluid img {
  max-width: 100%;
  height: auto;
}
.anchor {
  text-decoration: underline;
  font-family: $Raleway;
  font-weight: 500;
  font-size: 15px;
  color: #000000;
}
.element {
  min-width: 240px;
}
.card-proposition {
  height: 100%;
  width: 100%;
  min-width: 190px;
  img {
    width: 100%;
    height: 50%;
    object-fit: cover;
  }
}
.col-weekend {
  padding-left: 0;
  width: 100%;
}

.default-container {
  padding: 20px;
  margin: 0 3rem;
}
</style>
